import { cn } from "./classNames-DcGnTh2N.js";
import { useArgoDesign } from "./context-U293r3v-.js";
import { jsx } from "react/jsx-runtime";
import { Content, Portal, Root, Trigger } from "@radix-ui/react-hover-card";
//#region src/components/HoverCard/HoverCardContent.tsx
const HoverCardContent = ({ ref, className, align = "center", sideOffset = 4, children, ...props }) => {
	const renderArgo = useArgoDesign();
	return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Content, {
		ref,
		align,
		sideOffset,
		"data-slot": "hover-card-content",
		"data-argo": renderArgo,
		className: cn("tailwindcss-preflight", "tw:group/hover-card-content", "tw:z-[1051]", "tw:box-border", "tw:border", "tw:rounded-popover", "tw:min-w-32", "tw:origin-(--radix-hover-card-content-transform-origin)", "tw:max-h-[var(--radix-hover-card-content-available-height)]", "tw:p-4", "tw:shadow-md", "tw:border-neutral-150 tw:bg-white", "tw:data-[argo=true]:border-solid tw:data-[argo=true]:border-border tw:data-[argo=true]:bg-popover tw:data-[argo=true]:text-popover-foreground", "tw:data-[side=bottom]:slide-in-from-top-2", "tw:data-[side=left]:slide-in-from-right-2", "tw:data-[side=right]:slide-in-from-left-2", "tw:data-[side=top]:slide-in-from-bottom-2", "tw:data-[state=open]:animate-in", "tw:data-[state=open]:fade-in-0", "tw:data-[state=open]:zoom-in-95", "tw:data-[state=closed]:animate-out", "tw:data-[state=closed]:fade-out-0", "tw:data-[state=closed]:zoom-out-95", "tw:[&_svg.lucide:not([class*='tw:size-'])]:size-4", "tw:[&_svg]:shrink-0", className),
		...props,
		children
	}) });
};
//#endregion
//#region src/components/HoverCard/HoverCard.tsx
const HoverCard = ({ openDelay = 200, closeDelay = 200, ...rest }) => /* @__PURE__ */ jsx(Root, {
	...rest,
	openDelay,
	closeDelay
});
HoverCard.Content = HoverCardContent;
HoverCard.Trigger = Trigger;
//#endregion
export { HoverCard };

//# sourceMappingURL=HoverCard-BBdPYqEf.js.map